<template>
  <div :class="['my-steps', `is-${direction}`]" :style="cssVars">
    <div :class="['step-item', getStepStatus(1)]">
      <!-- 数字圆圈 -->
      <div class="step-icon">
        <span class="step-number">{{ 1 }}</span>
      </div>
      <!-- 连接线 -->
      <div class="step-tail"></div>
    </div>
    <div :class="['step-item', getStepStatus(2)]">
      <!-- 数字圆圈 -->
      <div class="step-icon">
        <span class="step-number">{{ 2 }}</span>
      </div>
      <!-- 连接线 -->
      <div class="step-tail"></div>
    </div>
    <div :class="['step-item', getStepStatus(3)]">
      <!-- 数字圆圈 -->
      <div class="step-icon">
        <span class="step-number">{{ 3 }}</span>
      </div>
      <!-- 连接线 -->
      <div class="step-tail"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    // 允许传入数组，也允许直接传入数字（节点个数）
    steps: {
      type: [Array, Number],
      required: false, // 设为非必传
      default: 3, // 默认展示 3 个步骤节点
    },
    current: { type: Number, default: 0 },
    direction: {
      type: String,
      default: "horizontal",
      validator: (val) => ["horizontal", "vertical"].includes(val),
    },
    activeColor: { type: String, default: "#F24334" },
    inactiveColor: { type: String, default: "#F24334" },
    finishColor: { type: String, default: "#F24334" },
  },
  computed: {
    // 统一转换为一个常规数组，方便 v-for 循环
    normalizedSteps() {
      if (typeof this.steps === "number") {
        return Array.from({ length: this.steps });
      }
      if (Array.isArray(this.steps)) {
        return this.steps;
      }
      return Array.from({ length: 3 }); // 防御性容错，如果传了非法格式默认给 3 个
    },
    cssVars() {
      return {
        "--active-color": this.activeColor,
        "--inactive-color": this.inactiveColor,
        "--finish-color": this.finishColor,
      };
    },
  },
  methods: {
    getStepStatus(index) {
      if (index < this.current) return "is-finish";
      if (index === this.current) return "is-active";
      return "is-wait";
    },
  },
};
</script>

<style scoped lang="scss">
/* 基础公共样式 */
.my-steps {
  display: flex;
  font-family: Arial, sans-serif;
}
.step-item {
  position: relative;
  display: flex;
  align-items: center;
}

/* 数字圆圈高亮样式 */
.step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  /* 核心改动：利用 box-shadow 在圆圈外部套一圈与背景同色的“隐形保护层” */
  /* 4px 代表数字和线之间的间距大小，可根据视觉效果自由调整 */
  box-shadow: 0 0 0 4px #ffffff;
  border: 1px solid #F24334; /* 红色边框 */
  background-color: #fff;        /* 填充背景色，使其变为空心 */
  color: #F24334;           /* 红色数字 */
  z-index: 2;
  transition: all 0.3s ease;

  .step-number {
    font-size: 13px;
    font-weight: bold;
    line-height: 1;
  }
}

.step-tail {
  position: absolute;
  background-color: var(--active-color);
}

/* ==========================================================================
   1. 横向布局样式 (Horizontal)
   ========================================================================== */
.my-steps.is-horizontal {
  flex-direction: row;
  width: 100%;
}
.my-steps.is-horizontal .step-item:last-child {
   margin-right: 10px;
}
.my-steps.is-horizontal .step-item:nth-child(2) {
  width: 50%;
}
.my-steps.is-horizontal .step-item:first-child {
  margin-left: 10px;
  width: 46%;
}
.my-steps.is-horizontal .step-tail {
  left: 12px;
  top: 50%;
  width: 100%;
  height: 2px;
  transform: translateY(-50%);
}
.my-steps.is-horizontal .step-item:last-child .step-tail {
  display: none;
}
.step-item.is-active {
  .step-icon {
    border-color: none;     /* 蓝色边框 */
    background-color: #F24334; /* 蓝色实心背景 */
    color: #ffffff;                        /* 白色数字 */
    transform: scale(1.1);                 /* 选中项微放大，更具焦点感 */
  }
}
.step-item.is-finish {
  .step-icon {
    border-color: none;     /* 蓝色边框 */
    background-color: #F24334; /* 蓝色实心背景 */
    color: #ffffff;                        /* 白色数字 */
    transform: scale(1.1);                 /* 选中项微放大，更具焦点感 */
  }
}
</style>
